<template>
  <div class="container">
    <template v-if="data.studioName">
      <div
          class="switching_studios_box"
          v-if="scheduleInfo.channelId?.split(',').length > 1"
      >
        <div class="user_info_box">
          <img class="user_pic" :src="data.studioAvatar"/>
          <p class="user_name">{{ data.studioName }}</p>
        </div>
        <p class="switching_btn" @click="handleSwitch">切换工作室</p>
      </div>
      <div v-if="!isShow" class="content">
        <div class="item_box">
          <div class="item">
            <div class="item_label">工作室名称:</div>
            <div class="item_value item_value_btn">
              {{ data.studioName }} <span @click="handleEdit">编辑</span>
            </div>
          </div>
          <div class="item">
            <div class="item_label">企业微信昵称:</div>
            <div class="item_value">{{ data.studioWechatName }}</div>
          </div>
          <template v-if="data.subjectType!=1">
            <div class="item">
              <div class="item_label">医院名称:</div>
              <div class="item_value">{{ data.hospitalName }}</div>
            </div>
            <div class="item" v-if="data.officialWebsite">
              <div class="item_label">官网:</div>
              <div class="item_value">{{ data.officialWebsite }}</div>
            </div>
            <div class="item" v-if="data.email">
              <div class="item_label">邮箱:</div>
              <div class="item_value">{{ data.email }}</div>
            </div>
          </template>
          <div class="item">
            <div class="item_label">手机号:</div>
            <div class="item_value">{{ data.phone }}</div>
          </div>
          <div class="item">
            <div class="item_label">工作室头像:</div>
            <div class="item_value">
              <div class="item_value_img">
                <van-image
                    fit="cover"
                    :src="data.studioAvatar"
                    @click="prevImg1(0, [data.studioAvatar])"
                >
                </van-image>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_label">企业微信二维码:</div>
            <div class="item_value">
              <div class="item_value_img">
                <van-image
                    fit="cover"
                    :src="data.studioWechatQrCode"
                    @click="prevImg1(0, [data.studioWechatQrCode])"
                >
                </van-image>
              </div>
            </div>
          </div>
          <!--          <div class="item">-->
          <!--            <div class="item_label">资格证:</div>-->
          <!--            <div class="item_value">-->
          <!--              <template v-if="data.certificationUrls">-->
          <!--                <van-image-->
          <!--                    fit="cover"-->
          <!--                    v-for="(item, index) in data.certificationUrls?.split(',')"-->
          <!--                    :key="index"-->
          <!--                    :src="item"-->
          <!--                    @click="prevImg1(index, data.certificationUrls?.split(','))"-->
          <!--                >-->
          <!--                </van-image>-->
          <!--              </template>-->
          <!--              <template v-else> 暂无</template>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="item">
            <div class="item_label">个人擅长:</div>
            <div class="item_value">
              {{ data.personalStrengths || "暂无" }}
            </div>
          </div>
          <div class="item">
            <div class="item_label">个人简介:</div>
            <div class="item_value">{{ data.intro || "暂无" }}</div>
          </div>
        </div>
        <div class="codeBtn" @click="isCode">发送推广海报给患者</div>
      </div>
      <editInfo
          ref="editStudioInfo"
          v-if="isShow"
          @handleChangeShow="handleChangeShow"
          :studioId="studioId"
      ></editInfo>
      <div class="layer" ref="canvasImg">
        <div class="layer_box">
          <div class="userInfo">
            <div>
              <img :src="studioAvatar" alt=""/>
            </div>
            <div class="userInfo_text">
              <span class="userInfo_text_name">{{ data.studioName }}</span>
              <span
              >推荐码：{{
                  data.channelCode?.substring(2)
                }}，来这里看看吧</span
              >
            </div>
          </div>
          <img class="code_img" :src="codeUrl" alt=""/>
          <p class="tips">微信扫一扫进入我的工作室</p>
        </div>
      </div>
      <van-popup v-model="isPoster" closeable close-icon="close">
        <div class="popup_box">
          <img class="poster" :src="imgUrl" alt=""/>
          <p class="tips">请长按图片保存到手机</p>
          <div class="poster_btn_box">
            <!-- <p
              @click="
                copy(
                  `https://hi.eok.com.cn/mini_program_scan.html?b=${data.channelCode}`
                )
              "
              class="poster_btn"
            >
              复制链接
            </p> -->
            <p
                @click="copy(`${data.studioName}:${data.channelCode.substring(2)}`)"
                class="poster_btn"
            >
              复制邀请码
            </p>
          </div>
        </div>
      </van-popup>
      <!--    切换工作室-->
      <van-popup
          v-model="isShowSwitch"
          lock-scroll
          round
          position="bottom"
          :close-on-click-overlay="false"
          :style="{ height: '400px' }"
      >
        <div class="studios_title_header">
          <p class="switching_studios_title">切换工作室</p>
          <van-icon @click="handleSwitch" name="cross" size="20"/>
        </div>
        <div class="studios_list_box">
          <div
              v-for="item in studiosList"
              :key="item.channelId"
              :class="[
              'studios_item',
              studioId == item.channelId ? 'studios_item_active' : '',
            ]"
              @click="changeStudio(item)"
          >
            <div class="studios_info_box">
              <img class="studios_pic" :src="item.studioAvatar" alt=""/>
              <div class="studios_user">
                <p class="studios_user_name">{{ item.studioName }}</p>
                <p class="studios_user_type">{{ item.studioType | getType }}</p>
              </div>
            </div>
            <van-icon
                color="red"
                v-if="studioId == item.channelId"
                size="20"
                name="checked"
            />
          </div>
        </div>
      </van-popup>
    </template>
    <template v-else>
      <van-empty description="暂无工作室"/>
    </template>
  </div>
</template>
<script>
import editInfo from "@/views/home/studioInformation/editInfo.vue";
import html2canvas from "html2canvas";
import {ImagePreview} from "vant";
import qrcode from "qrcode";
import {
  getStudioInfo,
  updateStudioInfo,
  getStaffSchedule,
  getStudios,
} from "@/api/home";
import {formatTime} from "@/hooks/function";
import {data} from "autoprefixer";

export default {
  name: "studioInformation",
  data() {
    return {
      isShow: false,
      codeUrl: "",
      studioAvatar: "",
      data: {},
      imgUrl: "",
      isPoster: false,
      isShowSwitch: false,
      studiosList: [],
      studioId: "",
      officialWebsite: "",
      email: "",
      hospitalName: "",
      scheduleInfo: {},
    };
  },
  components: {
    editInfo,
  },
  filters: {
    getType(value) {
      switch (Number(value)) {
        case 1:
          return "金牌经纪人";
          break;
        case 2:
          return "实习经纪人";
          break;
        case 3:
          return "SVIP";
          break;
        case 4:
          return "VIP";
          break;
        default:
          return "";
          break;
      }
    },
  },
  async mounted() {
    await this.getScheduleParams();
    await this.getChannelsList(2);
    await this.getStudioInfo(this.studioId);
  },
  methods: {

    // 获取工作室列表
    getChannelsList(type = 1) {
      console.log(this.scheduleInfo);
      let params = {
        ids: this.scheduleInfo.channelId,
      };
      return getStudios(params).then((res) => {
        this.studiosList = res.data;
        let channelCode = this.studiosList.map((item) => {
          return item.channelCode;
        })
        console.log(channelCode);
        sessionStorage.setItem("channelCode", channelCode.toString());
        if (type == 2) {
          this.studioId = res.data[0].channelId
        }
      });
    },
    // 获取会诊管理列表
    async getScheduleParams() {
      this.month = formatTime(new Date()).format("YYYY-MM");
      let scheduleParams = {
        date: formatTime(this.month).format("YYYY-MM-01"),
        staffNo: this.$store.state.assistantNo,
      };
      let {data: scheduleInfo} = await getStaffSchedule(scheduleParams);
      this.scheduleInfo = scheduleInfo;
      //this.studioId = scheduleInfo.channelId.split(",")[2];
      /* this.studioId = sessionStorage.getItem("studioId")
        ? sessionStorage.getItem("studioId")
        : scheduleInfo.channelId.split(",")[0];
      sessionStorage.setItem("studioId", this.studioId); */
    },
    async getStudioInfo(studioId) {
      return new Promise((resolve, reject) => {
        getStudioInfo({id: studioId})
            .then((res) => {
              if (res.code == 0) {
                this.data = res.data;
                this.saveImageToLocalStorage(res.data.studioAvatar);
              }
              resolve(true);
            })
            .catch(() => {
              reject(false);
            });
      });
    },
    handleEdit() {
      this.handleChangeShow();
    },
    handleChangeShow(val) {
      this.isShow = !this.isShow;
      if (val == 2) {
        this.getStudioInfo(this.studioId);
      }
    },
    handleSwitch() {
      this.isShowSwitch = !this.isShowSwitch;
      this.getChannelsList();
    },
    qrCode() {
      let that = this;

      try {
        var opts = {
          errorCorrectionLevel: "H",
          type: "image/jpeg",
          quality: 0.3,
          margin: 1,
          color: {
            light: "#fff",
          },
        };
        let url = `https://hi.eok.com.cn/mini_program_scan.html?b=${this.data.scene}`;
        qrcode.toDataURL(url, opts, async (err, base64Url) => {
          if (err) throw err;
          that.codeUrl = base64Url;
          that.$nextTick(async () => {
            that.createImage();
            // console.log(url, "url");
          });
        });
      } catch (error) {
        // console.log(error);
      }
    },
    isCode() {
      this.isPoster = true;
      this.qrCode();
    },
    async createImage() {
      try {
        const canvas = await html2canvas(this.$refs.canvasImg); // 在这里，将需要转换成图片的部分作为参数传入html2canvas
        const image = canvas.toDataURL(); // 将生成的canvas转换为DataURL格式
        this.imgUrl = image;
        // console.log(image); // 可以将image自行存储
      } catch (e) {
        throw new Error(e);
      }
    },
    prevImg1(index, arr) {
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    saveImageToLocalStorage(imageName) {
      // console.log("saveImageToLocalStorage");
      this.getBase64Image(imageName).then((dataURL) => {
        // console.log(dataURL);
        this.studioAvatar = dataURL;
      });
    },
    getBase64Image(src) {
      return new Promise((resolve) => {
        let xhr = new XMLHttpRequest();
        xhr.open("get", src, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (this.status == 200) {
            let blob = this.response;
            let oFileReader = new FileReader();
            oFileReader.onloadend = function (e) {
              const base64 = e.target.result;
              resolve(base64);
            };
            oFileReader.readAsDataURL(blob);
          }
        };
        xhr.send();
      });
    },

    copy(value) {
      const input = document.createElement("input");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$toast("复制成功");
    },
    // 切换工作室
    changeStudio(item) {
      this.studioId = item.channelId;
      console.log(this.studioId);
      //sessionStorage.setItem("studioId", this.studioId);
      // 刷新编辑工作室信息
      if (this.$refs.editStudioInfo) {
        this.$refs.editStudioInfo.init(this.studioId);
      } else {
        this.getStudioInfo(this.studioId);
      }
      this.isShowSwitch = false;
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100%;
}

.switching_studios_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
  box-sizing: border-box;
  background: #fff;

  .user_info_box {
    display: flex;
    align-items: center;

    .user_pic {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .user_name {
      font-size: 14px;
      color: #000;
    }
  }

  .switching_btn {
    font-size: 16px;
    color: #d61616;
  }
}

.content {
  height: 100%;
  padding: 12px;
  border-radius: 4px;
  background: #fff;

  .item_box {
    .item {
      display: flex;
      align-content: center;
      margin-bottom: 16px;

      .item_label {
        width: 25%;
        text-align: right;
      }

      .item_value {
        display: flex;
        margin-left: 5%;
        width: 70%;
        text-align: left;
        flex-wrap: wrap;

        :deep() .van-image__img {
          width: 90px;
          height: 90px;
          margin-left: 6px;
          margin-bottom: 6px;
          border-radius: 8px;
          cursor: pointer;
        }

        .item_value_img {
          display: flex;
          width: 90px;

          //height: 90px;
        }
      }

      .item_value_btn {
        display: flex;
        justify-content: space-between;

        span {
          color: #0082ef;
        }
      }
    }
  }

  .codeBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    background: #0082ef;
    color: #fff;
    border-radius: 4px;
  }
}

.popup_box {
  padding: 16px;

  .poster {
    margin: 0 auto;
    margin-top: 40px;
    width: 410px;
  }

  .tips {
    text-align: center;
  }

  .poster_btn_box {
    width: 400px;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 180px;
      height: 44px;
      background: #0082ef;
      color: #fff;
      border-radius: 4px;
    }

    .poster_btn_right {
      background: #d61616;
    }
  }
}

.layer {
  display: flex;
  flex-direction: column;
  width: 343px;
  padding: 60px 0 12px 0;
  box-sizing: border-box;
  background: linear-gradient(
          to right,
          pink 0%,
          pink 50%,
          paleturquoise 50%,
          paleturquoise 100%
  );
  align-items: center;
  margin-top: -10000px;

  .layer_box {
    background: #fff;
    width: 319px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .userInfo {
    display: flex;
    align-items: center;
    flex-direction: column;
    align-items: center;

    .userInfo_text {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      color: #7c807f;

      .userInfo_text_name {
        margin-bottom: 4px;
        font-size: 18px;
        color: #1b2120;
        font-weight: 500;
      }
    }

    img {
      margin-top: -20px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
  }

  .code_img {
    margin: 24px 0 0 0;
    width: 200px;
    height: 200px;
  }

  .tips {
    text-align: center;
    color: #7c807f;
  }
}

.studios_title_header {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
  align-items: center;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1000;

  .switching_studios_title {
    font-size: 20px;
    font-weight: bold;
  }
}

.studios_list_box {
  padding: 12px;
  box-sizing: border-box;

  .studios_item {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #eee;
    border-radius: 6px;
    margin-bottom: 10px;

    .studios_info_box {
      display: flex;
      align-items: center;

      .studios_pic {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .studios_user {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 12px;
        //align-items: center;

        .studios_user_name {
          margin: 0 !important;
          font-size: 14px;
          color: #000;
        }

        .studios_user_type {
          margin-top: 6px;
          font-size: 12px;
          color: #999;
        }
      }
    }
  }

  .studios_item_active {
    border: 1px solid #de0c0c;
  }
}
</style>